import { Table, Row, Col } from "react-bootstrap";
import { UserDataContext } from "../components/UserDataContext";
import { TaskContext } from "../components/TaskContext";
import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import "../components/button.css";
import Button from "@mui/material/Button";
import { marginBottom } from "../App";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../components/theme";
import "../components/Dots.css";
import SendIcon from "@mui/icons-material/Send";
import { apiRequest } from "../components/Config";
import SwapVertIcon from "@mui/icons-material/SwapVert";

export default function PerformersData() {
  const { userData } = useContext(UserDataContext);
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const [showRegister, setShowRegister] = useState(false);
  const [showPerformers, setShowPerformers] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [searchMode, setSearchMode] = useState(false);
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "asc",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 1000;
  const [text, setText] = useState("Pobieranie danych...");
  const { taskId, setTaskId } = useContext(TaskContext);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await apiRequest("searchtasksexcel", "POST", {
          param: searchValue,
        });
        if (Array.isArray(response)) {
          setData(response);
          //console.log("td: ", response);
        } else {
          console.error("Otrzymane dane nie są tablicą:", response.data);
          setData([]);
        }
        if (response.length === 0)
          setText("Brak danych spełniających kryteria wyszukiwania...");
      } catch (error) {
        console.error(error);
      }
    };

    if (userData) fetchData();
  }, [userData, searchValue]);

  const refreshData = () => {
    const fetchData = async () => {
      try {
        const response = await apiRequest("searchtasksexcel", "POST", {
          param: searchValue,
        });
        //console.log("response data: ", response);
        setData(response);
        if (response.length === 0)
          setText("Brak danych spełniających kryteria wyszukiwania...");
      } catch (error) {
        console.error("Błąd podczas odświeżania danych:", error);
      }
    };
    if (userData) fetchData();
  };

  const handleTaskEdit = (id) => {
    setTaskId(id);
    setShowRegister(false);
    navigate(`/taskedit`);
  };
  const sortedData = Array.isArray(data)
    ? [...data].sort((a, b) => {
        if (sortConfig.key === null) return 0;
        const direction = sortConfig.direction === "asc" ? 1 : -1;

        if (a[sortConfig.key] < b[sortConfig.key]) {
          return -1 * direction;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return 1 * direction;
        }
        return 0;
      })
    : [];
  const paginatedData = sortedData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleChangePage = (event, page) => {
    setCurrentPage(page);
  };

  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  const handleSearch = (e) => {
    setSearchValue(e.target.value);
    if (e.target.value.length > 0) {
      setSearchMode(true);
    } else {
      setSearchMode(false);
    }
  };

  const handlePerformers = (id) => {
    if (userData.permId === "1") {
      setShowPerformers(!showPerformers);
      setTaskId(id);
    }
  };

  return (
    <div>
      <ThemeProvider theme={theme}>
        <Row style={{ marginBottom }}>
          <Col xs={6} sm={6}>
            <h4>
              <a href="https://pzitbrz.pl/api/export/excel">
                Zlecenia - raport zbiorczy
              </a>
            </h4>
          </Col>
        </Row>
      </ThemeProvider>
      <div className="table-responsive">
        <Table bordered hover>
          <thead>
            <tr>
              <th>LP</th>
              <th>
                <span style={{ display: "flex", alignItems: "center" }}>
                  <SwapVertIcon
                    onClick={() => requestSort("receiveData")}
                    style={{ cursor: "pointer", marginRight: "0.6em" }}
                  />
                  Data
                </span>
              </th>

              <th>
                <span style={{ display: "flex", alignItems: "center" }}>
                  <SwapVertIcon
                    onClick={() => requestSort("reporter")}
                    style={{ cursor: "pointer", marginRight: "0.6em" }}
                  />
                  Zleceniodawca
                </span>
              </th>
              <th>
                <span style={{ display: "flex", alignItems: "center" }}>
                  <SwapVertIcon
                    onClick={() => requestSort("topic")}
                    style={{ cursor: "pointer", marginRight: "0.6em" }}
                  />
                  Temat
                </span>
              </th>
              <th>
                <span style={{ display: "flex", alignItems: "center" }}>
                  <SwapVertIcon
                    onClick={() => requestSort("location")}
                    style={{ cursor: "pointer", marginRight: "0.6em" }}
                  />
                  Miejscowość
                </span>
              </th>
              <th>
                <span style={{ display: "flex", alignItems: "center" }}>
                  <SwapVertIcon
                    onClick={() => requestSort("performerName")}
                    style={{ cursor: "pointer", marginRight: "0.6em" }}
                  />
                  Wykonawca
                </span>
              </th>
              <th>
                <span style={{ display: "flex", alignItems: "center" }}>
                  <SwapVertIcon
                    onClick={() => requestSort("status")}
                    style={{ cursor: "pointer", marginRight: "0.6em" }}
                  />
                  Status
                </span>
              </th>
              <th>
                <span style={{ display: "flex", alignItems: "center" }}>
                  <SwapVertIcon
                    onClick={() => requestSort("nettoPerformer")}
                    style={{ cursor: "pointer", marginRight: "0.6em" }}
                  />
                  Wartość netto - Wykonawca
                </span>
              </th>
              <th>Wartość oferty do Zleceniodawcy</th>
              <th>Narzut dla PZITB [%]</th>
            </tr>
          </thead>
          {data.length > 0 && userData.userId ? (
            <tbody>
              {paginatedData.map((item, index) => (
                <tr key={index}>
                  <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                  <td>{item.receiveData}</td>
                  <td>{item.reporter}</td>
                  <td>{item.topic}</td>
                  <td>{item.location}</td>
                  <td>{item.fullName}</td>
                  <td>{item.status} </td>
                  <td>{item.nettoPerformer} </td>
                  <td>{item.allPrice} </td>
                  <td>{item.pzitbFactor} </td>
                </tr>
              ))}
            </tbody>
          ) : (
            <tbody>
              <tr>
                <td colSpan="8" style={{ textAlign: "center" }}>
                  <h6>{text}</h6>
                </td>
              </tr>
            </tbody>
          )}
        </Table>
      </div>
    </div>
  );
}
